// extracted by mini-css-extract-plugin
module.exports = {"noquotes":"NoQuotesFound_noquotes__2CguY"};